import axios from "axios";
import { API_ENDPOINTS } from "../api-urls";

// Helper function to handle API requests
const handleRequest = async (requestFn, endpoint) => {
  try {
    console.log(`Making API request to: ${endpoint}`); // Log before request
    const response = await requestFn();
    console.log(`Response received from: ${endpoint}`, response.data); // Log after success
    if (response.status >= 200 && response.status < 300) {
      return response.data;
    } else {
      throw new Error(`Error: ${response.status} - ${response.statusText}`);
    }
  } catch (error) {
    console.error(`API Error at ${endpoint}:`, error.response?.data || error.message);
    throw error;
  }
};
const getAuthToken = () => {
  const token = localStorage.getItem("authToken");
  return token ? `Bearer ${token}` : null;
};

// Get all orders for a user
export const fetchUserOrdersAPI = async () => {
  const token = getAuthToken();
  const user_id = localStorage.getItem("user_id");
  if (!token || !user_id) throw new Error("Authentication token missing.");

  const endpoint = `${API_ENDPOINTS.orders}`;
  return handleRequest(
    () =>
      axios.get(endpoint, {
        headers: { Authorization: token },
      }),
    endpoint
  );
};

// Get order details by ID
export const fetchOrderDetailsByIdAPI = async (orderId) => {
  const token = getAuthToken();
  const user_id = localStorage.getItem("user_id");
  if (!token || !user_id) throw new Error("Authentication token missing.");

  const endpoint = `${API_ENDPOINTS.orders}getOrderDetailsById/${orderId}`;
  return handleRequest(() => axios.get(endpoint,{
    headers: { Authorization: token },
  }),
   endpoint);
};

// Create a new order
export const createOrderAPI = async (orderData) => {
  const endpoint = `${API_ENDPOINTS.orders}/create`;
  return handleRequest(() => axios.post(endpoint, orderData), endpoint);
};

// Update an existing order
export const updateOrderAPI = async (orderId, updatedOrderData) => {
  const endpoint = `${API_ENDPOINTS.orders}/update/${orderId}`;
  return handleRequest(() => axios.put(endpoint, updatedOrderData), endpoint);
};

// Cancel an order
export const cancelOrderAPI = async (orderId) => {
  const endpoint = `${API_ENDPOINTS.orders}/cancel/${orderId}`;
  return handleRequest(() => axios.post(endpoint), endpoint);
};

// Return a product
export const returnProductAPI = async (returnData) => {
  const endpoint = `${API_ENDPOINTS.orders}/return`;
  return handleRequest(() => axios.post(endpoint, returnData), endpoint);
};

// Add notes to an order
export const addNotesToOrderAPI = async (orderId, notesData) => {
  const endpoint = `${API_ENDPOINTS.orders}/notes/${orderId}`;
  return handleRequest(() => axios.post(endpoint, notesData), endpoint);
};
